
import { Options, Vue } from 'vue-class-component';
import ModalBox from '@/shared/components/modal-box/index.vue';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { AuditTrailView } from '@/shared/modules/typescript-trustapi-client/models';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { Prop } from 'vue-property-decorator';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';

@Options({
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator
  },
  mixins: [FormatDateTimeMixin]
})
export default class AuditTrailModal extends Vue {

  @Prop({ default: ''})
  private applicationName!: string;

  @Prop({ default: ''})
  private applicationTypeName!: string;

  @Prop({ default: []})
  private auditTrailData!: AuditTrailView[];

  @Prop({ default: false})
  private loadingContent!: boolean;

  @Prop({ default: false})
  private errorLoadingContent!: boolean;


  private tableHeadings = [
    { text: 'Date', value: 'data', sortable: false },
    { text: 'Change', value: 'change', sortable: false },
    { text: 'Changed by', value: ',changedBy', sortable: false },
  ];

  private closeModal(): void {
    this.$emit('closeAuditTrailModal');
  }

}

